import consumer from "./consumer"

consumer.subscriptions.create("CommentChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    const timeline = document.querySelector(".activity-timeline")

    if (data.event_id) {
      const existing = document.getElementById(`project_event_${data.event_id}`)
      if (existing) {
        existing.outerHTML = data.comment_html
      }
      return
    }

    if (timeline) {
      timeline.insertAdjacentHTML("afterbegin", data.comment_html)
    }
  }
});
